import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import { Button } from "primereact/button";

const PurchaseorderSupplierListComponent = (props) => {

  const { t } = props;
  const history = useHistory();
  const { entity, action, id } = useParams();
  const [purchaseorderSuppliers, setPurchaseorderSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      purchase_order: { value: id, matchMode: 'equals' }
    }
  });
  const [expandedRows, setExpandedRows] = useState(null);
  const poStatus = String(props.purchaseOrderStatus || '').toUpperCase();
  const canEditPo = ['NEW', 'IN_PROGRESS'].includes(poStatus);

  let loadLazyTimeout = null;

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const query = window.App.transformQueryParams(lazyParams);
      apiCall('get', '/api/v2/purchase-order-supplier' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setPurchaseorderSuppliers(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    let _lazyParams = { ...lazyParams, ...event };
    setLazyParams(_lazyParams);
  };

  const onSort = (event) => {
    let _lazyParams = { ...lazyParams, ...event };
    setLazyParams(_lazyParams);
  };

  const onFilter = (event) => {
    let _lazyParams = { ...lazyParams, ...event };
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  };

  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3) },
        { label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4) },
      ];

      return (
        <>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={(e) => setRows(e.target.value)}
            appendTo={document.body}
          />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      );
    }
  };

  const actionBodyTemplate = (rowData) => {
    const hasRole = localStorage.getItem('roles')?.toString().includes('role_');
    const editable = hasRole && canEditPo;
    const canCreateDeliveryNote = rowData.ordered && canEditPo;
    return (
      <React.Fragment>
        {editable && (rowData.items || []).length === 0 && (
          <Button icon="pi pi-trash" className="p-button-danger p-mr-2" tooltip={t('delete')}
            onClick={async () => {
              if (!window.confirm(t('deleteEmptySupplierOrderConfirm'))) return;
              setLoading(true);
              try {
                await apiCall('delete', `/api/v2/purchase-order-supplier/${rowData.id}`);
                loadLazyData();
              } catch (error) {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                setLoading(false);
              }
            }}/>
        )}
        {editable && (
          <Button
            icon="pi pi-pencil"
            className="p-button-warning p-mr-2"
            tooltip={t('edit')}
            tooltipOptions={{ position: 'left' }}
            onClick={() => {
              history.push(
                '/procurement/purchase-order/read/' +
                id +
                '?update=purchaseorder-supplier&purchaseorderSupplierId=' +
                rowData.id
              );
            }}
          />
        )}
        <Button
          icon="pi pi-truck"
          className="p-button-info p-mr-2"
          tooltip={t('deliveryNoteRegistration')}
          tooltipOptions={{ position: 'left' }}
          disabled={!canCreateDeliveryNote}
          onClick={() => {
            const partnerName = rowData.partner?.name ? encodeURIComponent(rowData.partner.name) : '';
            const partnerId = rowData.partner?.id || '';

            history.push(
              `/procurement/${entity}/${action}/${id}` +
              `?create=inventorydocument` +
              `&type=transfer-supplier` +
              `&purchaseorderSupplierId=${rowData.id}` +
              `&partnerId=${partnerId}` +
              `&partnerName=${partnerName}`
            );
          }}
        />
        {/*<Button*/}
        {/*  icon="pi pi-eye"*/}
        {/*  className="p-button p-mr-2"*/}
        {/*  tooltip={t('view')}*/}
        {/*  tooltipOptions={{ position: 'left' }}*/}
        {/*  onClick={() => {*/}
        {/*    history.push(*/}
        {/*      '/procurement/purchase-order/read/' +*/}
        {/*      id +*/}
        {/*      '?read=purchaseorder-supplier&purchaseorderSupplierId=' +*/}
        {/*      rowData.id*/}
        {/*    );*/}
        {/*  }}*/}
        {/*/>*/}
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (purchaseorderSuppliers?.length > 0) {
      // Expand all rows initially
      const allRowsExpanded = {};
      purchaseorderSuppliers.forEach((row) => {
        allRowsExpanded[row.id] = true; // 'id' should match the `dataKey` in DataTable
      });

      setExpandedRows(allRowsExpanded);
    }
  }, [purchaseorderSuppliers]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPurchaseorderSupplierList]);

  return (
    <>
      <DataTable
        size={localStorage.getItem('scale')}
        emptyMessage={t('noResults')}
        value={purchaseorderSuppliers}
        paginator
        first={lazyParams.first}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        onFilter={onFilter}
        filters={lazyParams.filters}
        loading={loading}
        lazy
        paginatorTemplate={pager}
        rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        ref={dt}
        dataKey="id"
        rowExpansionTemplate={(rowData) => {
          return (
            <div className="expanded-section">
              <h4 className="expanded-section__title">
                <i className="pi pi-list" />
                {t('items')}
              </h4>
              <div className="expanded-section__content">
                <DataTable size={"small"}
                          autoLayout={true}
                          value={rowData.items}
                          responsiveLayout="scroll"
                          stripedRows
                          emptyMessage={t('noProduct')}
                          dataKey="id"
                >
                  <Column header={t('columnProduct')} field={"material.name"} style={{width: '50%'}}></Column>
                  <Column header={t("upc")} field={"material.upc"}></Column>
                  <Column header={t('columnUnitPrice')} field={"unit_price"} body={(itemRow) => {
                    return (
                      <>
                        {window.App.currencyFormatter(rowData?.currency, itemRow?.unit_price)}
                      </>
                    )
                  }}></Column>
                  <Column header={t('columnVat')} field={"vat_rate.label"}></Column>
                  <Column header={t('columnQuantity')} className={"p-text-right"} style={{width: '10%'}} body={(rowData) => {
                    return(
                      <>{rowData?.quantity} {rowData?.unit?.name}</>
                    )
                  }}></Column>
                </DataTable>
              </div>
            </div>
          )
        }}
        expandedRows={expandedRows}
      >
        <Column
          field="partner.name"
          header={t('columnSupplier')}
          sortable
          filter
        />
        <Column
          field="ordered"
          header={t('columnOrderSubmitted')}
          sortable
          body={(rowData) => (
            <span className="p-d-inline-flex p-ai-center" style={{ gap: 6 }}>
              <i className={rowData.ordered ? 'pi pi-check text-success' : 'pi pi-times text-danger'} />
              <span>{rowData.ordered ? t('yes') : t('no')}</span>
            </span>
          )}
        />
        <Column
          field="created_at"
          header={t('columnCreatedAt')}
          sortable
          body={(rowData) => (
            <>{rowData.created_at && window.App.formatDateValue(rowData.created_at)}</>
          )}
        />
        <Column
          field="updated_at"
          header={t('columnUpdatedAt')}
          sortable
          body={(rowData) => (
            <>{rowData.updated_at && window.App.formatDateValue(rowData.updated_at)}</>
          )}
        />
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  );
};

export default withTranslation('common')(PurchaseorderSupplierListComponent);
